import { Injectable } from '@angular/core';
import {
  BackendService,
  BaseApiService,
  RequestFacadeModel,
  RequestModel,
  RequestType,
} from '@cf/core';
import { EventDTO, IEventContainer } from '@cf/temp/services';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService extends BaseApiService {
  constructor(backendService: BackendService) {
    super(backendService, 'events');
  }

  events(dto: EventDTO): Observable<IEventContainer[]> {
    const request: RequestModel<EventDTO> = new RequestModel<EventDTO>({
      url: this.getFullUrl(''),
      requestBody: dto,
    });
    const requestFacade: RequestFacadeModel<EventDTO> = new RequestFacadeModel<EventDTO>({
      requestType: RequestType.post,
      request,
    });
    return this.send<IEventContainer[], EventDTO>(requestFacade).pipe(
      map((res: any) => res.events),
    );
  }

  // calendarEvents(dto: EventDTO): Observable<IEventContainer[]> {
  //   const request: RequestModel<EventDTO> = new RequestModel<EventDTO>({
  //     url: this.getFullUrl(''),
  //     requestBody: dto,
  //   });
  //   const requestFacade: RequestFacadeModel<EventDTO> =
  //     new RequestFacadeModel<EventDTO>({
  //       requestType: RequestType.post,
  //       request,
  //     });
  //   return this.send<IEventContainer[], EventDTO>(requestFacade).pipe(
  //     map((res: any) => res.events),
  //   );
  // }

  event(id: number): Observable<IEventContainer[]> {
    return this.getEntity(id);
  }
}
